import { DateTime } from "luxon"
import { useContext } from "react"

// Context
import { UserContext } from "../../../context/userContext"

//PrimeReact
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Button } from "primereact/button"

//Styles
import assessStyles from "../../../styles/assessments/Assessment.module.css"

//Assessments components
import AssessmentListTableCreator from "./AssessmentListTableCreator"
import AssessmentListTableSharedBy from "./AssessmentListTableSharedBy"
import { Paginator } from "primereact/paginator"
import AssessmentListTableStatus from "./AssessmentListTableStatus"

export default function AssessmentListTable({
  dataSet,
  isLoadingUsers,
  users,
  activeOrganization,
  organizations,
  displayType,
  onSetPageSetup,
  onEdit,
  onClone,
  onPreviewAssessment,
}) {
  const userCtx = useContext(UserContext)

  const CreationDateColumnTemplate = (rowData) => {
    let date = rowData.createdDate

    if (!!date) {
      const dateFromiso = DateTime.fromISO(date, { zone: "utc" })

      date = dateFromiso.toLocal().toLocaleString()
    }

    return <>{date}</>
  }

  const ActionsColumnTemplate = (rowData) => {
    let iconName = "edit"
    let tooltip = "Edit assessment profile"

    if (rowData.isSystemType && userCtx.session.user.staff_role === 1) {
      iconName = "edit"
    } else if (
      rowData.isSystemType ||
      rowData.organizationId !== activeOrganization
    ) {
      iconName = "visibility"
      tooltip = "View assessment profile"
    }

    return (
      <div className={assessStyles.actionButtonContainer}>
        <Button
          type="button"
          onClick={() => {
            onEdit(rowData.id)
          }}
          className={assessStyles.actionButtonPurple}
          tooltip={tooltip}
          tooltipOptions={{ position: "bottom" }}
        >
          <span className={`material-icons`}>{iconName}</span>
        </Button>
        <Button
          type="button"
          onClick={() => {
            onPreviewAssessment(rowData.id)
          }}
          className={assessStyles.actionButtonPurple}
          tooltip="Preview assessment"
          tooltipOptions={{ position: "bottom" }}
        >
          <span className={`material-icons`}>{"preview"}</span>
        </Button>
        {onClone && dataSet?.isActive ? (
          <Button
            type="button"
            onClick={() => {
              onClone(rowData.id, rowData.name)
            }}
            className={assessStyles.actionButtonPurple}
            tooltip="Clone assessment"
            tooltipOptions={{ position: "bottom" }}
          >
            <span className={`material-icons`}>{"content_copy"}</span>
          </Button>
        ) : null}
      </div>
    )
  }

  const AccessLevelTemplate = (rowData) => {
    return (
      <span style={{ textTransform: "capitalize" }}>{rowData.accessLevel}</span>
    )
  }

  return (
    <>
      <DataTable
        value={dataSet?.assessments || []}
        className={assessStyles.dataTable}
      >
        <Column header={"Name"} field="name" />
        <Column header={"Description"} field="description" />
        {displayType === "owned" ? (
          <Column header={"Access level"} field="accessLevel" />
        ) : null}
        {displayType === "shared" ? (
          <Column header={"Access level"} body={AccessLevelTemplate} />
        ) : null}
        {displayType === "shared" ? (
          <Column
            header={"Shared by"}
            body={(rowData) => (
              <AssessmentListTableSharedBy
                rowData={rowData}
                isLoadingUsers={isLoadingUsers}
                organizations={organizations}
              />
            )}
          />
        ) : null}
        <Column
          header={"Created By"}
          body={(rowData) => (
            <AssessmentListTableCreator
              rowData={rowData}
              isLoadingUsers={isLoadingUsers}
              users={users}
            />
          )}
        />
        <Column header={"Created On"} body={CreationDateColumnTemplate} />
        {displayType === "system" || displayType === "shared" ? (
          <Column
            header={"On/Off"}
            body={(rowData) => {
              return <AssessmentListTableStatus rowData={rowData} />
            }}
          />
        ) : null}
        {onEdit ? (
          <Column
            header={""}
            body={ActionsColumnTemplate}
            bodyStyle={{ width: displayType === "owned" ? "70px" : "109.5px" }}
          />
        ) : null}
      </DataTable>
      <Paginator
        first={dataSet ? (dataSet?.pageNum - 1) * dataSet?.pageSize : 0}
        rows={dataSet?.pageSize || 0}
        totalRecords={dataSet?.numTotal || 0}
        onPageChange={(setup) => {
          onSetPageSetup(setup)
        }}
      />
    </>
  )
}
